import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';
import { Tabs } from '@/ui';

const COUNT_NOUN = {
  pending: ['pendiente', 'pendientes'],
  answered: ['solicitud', 'solicitudes'],
};

export default function SolicitudesHeader({
  count,
  table = false,
  focusHeading = false,
  answered = false,
  onViewChange,
}) {
  const titleRef = useRef(null);
  useEffect(() => {
    if (focusHeading) titleRef.current?.focus();
  }, [focusHeading]);

  return (
    <header className="sol-head">
      <h1 className="sol-title" ref={titleRef} tabIndex={-1}>
        Solicitudes
      </h1>
      {onViewChange ? (
        <Tabs
          items={[
            { key: 'pendientes', label: 'Pendientes', active: !answered },
            { key: 'respondidas', label: 'Respondidas', active: answered },
          ]}
          onChange={(_i, item) => onViewChange(item.key === 'respondidas')}
        />
      ) : null}
      {count > 0 && !answered && !table ? (
        <p className="sol-hint">Desliza para aceptar o rechazar</p>
      ) : null}
      {count != null ? (
        <p className="sol-count">
          {/* Respondidas also lists invites the API closed when the firm paid
              someone else, so its count stays neutral. */}
          {count}{' '}
          {COUNT_NOUN[answered ? 'answered' : 'pending'][count === 1 ? 0 : 1]}
        </p>
      ) : null}
    </header>
  );
}

SolicitudesHeader.propTypes = {
  count: PropTypes.number,
  table: PropTypes.bool,
  focusHeading: PropTypes.bool,
  answered: PropTypes.bool,
  onViewChange: PropTypes.func,
};
